import React, { useContext, useState } from 'react';
import {
  Card,
  GridContainer,
  Link,
  ModalDialog,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@vp/swan';
import { OrderConsoleContext } from '../../../contexts/OrderConsoleContext';

const FailuresDisplayCard = ({ lineItemId }) => {
  const { failures } = useContext(OrderConsoleContext);

  const failureDetailsExist =
    failures &&
    failures.some(
      f => f.itemInfo?.itemId === lineItemId && f.failureDescription
    );

  return failureDetailsExist ? (
    <GridContainer>
      <Card bordered evenHeight>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Failure Type</TableCell>
              <TableCell>Resolution Steps</TableCell>
              <TableCell>Failure Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {failures.map(failure => (
              <TableRow>
                <TableCell>
                  <Typography textSize={7}>{failure.type}</Typography>
                </TableCell>
                <TableCell>
                  <Typography textSize={7}>
                    {failure.remediationSteps}
                  </Typography>
                </TableCell>
                {failureDetailsExist && (
                  <TableCell>
                    <Typography textSize={7}>
                      {failure.failureDescription}
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </GridContainer>
  ) : (
    <GridContainer>
      <Typography textSize={6}>No active failures</Typography>
    </GridContainer>
  );
};

export default FailuresDisplayCard;
